import React, {Component} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {ToastContainer, toast} from 'react-toastify';
import {isEmpty} from 'lodash';
import FadeLoader from 'react-spinners/FadeLoader';
import {Redirect, Link} from 'react-router-dom';

import {getToken, getUser} from '../../utils/TokenManager';
import * as AuthAction from "../../actions/AuthAction";
import logo from '../../public/assets/images/symphony_logo_new.jpg';
import loginImg from '../../public/assets/images/login-img.jpg';
import LoginService from '../../services/LoginService';
import FormValidator from "../../validations/FormValidator";
import {ValidationRules} from "./ValidationRules";
import {css} from 'react-emotion';

const override = css`
    margin: auto;
`;

class ResetPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isValidGuid: false,
            guid: '',
            passwordDetail: {
                new_password: '',
                confirm_password: ''
            },
            errors: {},
            isLoading: false
        };
        this.validator = new FormValidator(ValidationRules);
    }

    componentDidMount = () => {
        this.getInitialState();
    };

    getInitialState = async () => {
        let guid = '';
        if(!(isEmpty(window.location)) && !(isEmpty(window.location.search))) {
            guid = window.location.search;
        }
        try {
            let result = await LoginService.checkValidGuid(guid);

            if (200 === result.status) {
                this.setState({isValidGuid: true, guid});
            }
        } catch (error) {
            toast.error("The URL is invalid or expired.", {autoClose: 5000});
        }
    };

    onChange = (event) => {
        const passwordDetail = {...this.state.passwordDetail};
        passwordDetail[event.target.name] = event.target.value;
        return this.setState({passwordDetail});
    };

    resetPassword = async (e) => {
        e.preventDefault();
        this.setState({isLoading: true});
        const {passwordDetail, guid} = this.state;
        let validationStatus = this.validator.validateForm(passwordDetail);
        if (!validationStatus.isValid) {
            this.setState((prevState) => ({
                errors: validationStatus.errors,
            }));
        } else if (passwordDetail.new_password !== passwordDetail.confirm_password) {
            let errors = {...this.state.errors};
            errors['confirm_password'] = 'New and Confirm Password Does not match.';
            this.setState((prevState) => ({errors: errors}));
        } else {
            try {
                let result = await LoginService.recoveryPassword(passwordDetail, guid);
                if (200 === result.status) {
                    toast.success("Password changed successfully. Please login with new credentials.");
                    let newPasswordDetails = {
                        new_password: '',
                        confirm_password: ''
                    }
                    this.setState({passwordDetail: newPasswordDetails});
                    window.location.replace('/login');
                }
            } catch(error) {
                toast.error("The URL is invalid or expired.", {autoClose: 5000});
            }
        }
        this.setState({
            isLoading: false
        });
        return false;
    };

    render() {
        const {passwordDetail, errors, isValidGuid, isLoading} = this.state;
        const {auth} = this.props;

        if (auth.isAuthenticated || (typeof getToken() && !isEmpty(getToken()))) {
            if (getUser().is_installation_completed) {
                let prevURL = this.props.prevURL;
                if (
                    prevURL === '/' || prevURL === '/login' || 
                    prevURL === '/recovery' || prevURL === '/reset-password'
                ) {
                    prevURL = '/home'
                }
                return (<Redirect to={prevURL} />);
            } else {
                return (<Redirect to="/installation-wizard" />);
            }
        }

        return (
            <div className="login-page">
                <div className="login-box">
                    <div className="left-login-box">
                        <img src={loginImg} height="100%" alt="Login" />
                    </div>
                    <div className="right-login-box">
                        <img src={logo} alt="Logo" className="login-logo" />
                        <form className="auth-form">
                            {isValidGuid ? 
                                <div className="border p-3">
                                    <label>
                                        Enter your new password and click 'Reset Passowrd' button.
                                    </label>
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text bg-success text-white">
                                                <i className="fa fa-key" aria-hidden="true"></i>
                                            </span>
                                        </div>
                                        <input className="form-control form-control-lg" 
                                            placeholder="New Password" name="new_password"
                                            aria-label="Password"  required
                                            type="password" 
                                            value={passwordDetail.new_password} 
                                            onChange={this.onChange}
                                        />
                                        {errors.new_password ? 
                                            <span className="span-error"> 
                                                {errors.new_password}
                                            </span> : ''
                                        }
                                    </div>
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text bg-warning text-white">
                                                <i className="fa fa-key"></i>
                                            </span>
                                        </div>
                                        <input className="form-control form-control-lg" 
                                            placeholder="Confirm New Password"
                                            aria-label="Confirm Password" 
                                            name="confirm_password"
                                            aria-describedby="basic-addon1" 
                                            required type="password"
                                            value={passwordDetail.confirm_password} 
                                            onChange={this.onChange}
                                        />
                                        {errors.confirm_password ? 
                                            <span className="span-error"> 
                                                {errors.confirm_password}
                                            </span> : ''
                                        }
                                    </div>
                                    <hr/>
                                    <div className="form-group mb-0">
                                        {isLoading ?
                                            <FadeLoader
                                                color={'#4fb8a5'}
                                                loading={isLoading}
                                                size={24}
                                                className={override}
                                            /> :
                                            <div className="d-flex flex-column align-items-center">
                                                <button onClick={this.resetPassword} 
                                                    className="btn btn-success w-50 font-weight-bold" 
                                                    type="submit"
                                                >Reset Password</button>
                                                <Link to='/login' className="a-text-underline mt-2">
                                                    Back to Login
                                                </Link>
                                            </div>
                                        }
                                    </div>
                                </div>
                                :
                                <div className="text-center p-3 border">
                                    The URL is invalid or expired.
                                    <br/><br/>
                                    <Link to='/login' className="a-text-underline">
                                        Back to Login
                                    </Link>
                                </div>
                            }
                        </form>
                    </div>
                </div>
                <div className="mt-2 text-center">
                    <q className="text-left">
                        <i>
                            Success is not final. Failure is not fatal. 
                            It's the courage to continue that counts.
                        </i>
                    </q>
                    <b> - Winston Churchill</b>
                </div>
                <div className="clear login-footer">
                    <p>
                        Need Help? Call Support at 972-961-4798 
                        or email at tom@comp21.biz or
                        <a className="text-success" 
                            href="https://us02web.zoom.us/j/9722396890"
                        > Click Here </a> for a Zoom meeting
                    </p>
                </div>
                <ToastContainer position={toast.POSITION.TOP_CENTER} autoClose={2000}/>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        auth: state.AuthReducer
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(AuthAction, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);



// WEBPACK FOOTER //
// ./src/components/login/ResetPassword.js